import React from 'react';
import './Header.css';
import logo_img from '../assets/logo_text_web.png';

import phone_img from '../assets/icons/phone.svg';
import message_img from '../assets/icons/message.svg';
import channel_img from '../assets/icons/channel_old.svg';
import { Link } from "react-router-dom";

const header_links = [
    {
        name: 'Позвонить',
        link: 'tel:+79194946782',
        icon: phone_img,
        type: 'external'
    },
    {
        name: 'Написать',
        link: 'https://t.me/obmenvpermi',
        icon: message_img,
        type: 'telegram'
    },
    {
        name: 'Телеграм Канал',
        link: 'https://t.me/obmen_v_prm',
        icon: channel_img,
        type: 'telegram'
    },
];

const Header = () => {


    const handleClick = (link, type) => {
        const tg = window.Telegram?.WebApp;

        // если не в мини-аппе → всегда открываем в браузере
        if (!tg) {
            window.open(link, "_blank");
            return;
        }

        if (type === "telegram") {
            tg.openTelegramLink(link);
        } else if (type === "external") {
            // именно внешний → в браузере
            window.open(link, "_blank");
        } else {
            // дефолтный кейс → внутри WebApp
            tg.openLink(link);
        }
    };



    return (
        <div className="header-wrapper">
            <Link to="/" className="header-logo-container">
                <img className="header-logo" src={logo_img} alt="CashCoin Logo" />
            </Link>

            <div className="header-links">
                <div className="header-links-pillow" />
                {header_links.map((item, i) => (
                    <button
                        key={i}
                        className="square round btn white-gradient"
                        onClick={() => handleClick(item.link, item.type)}
                    >
                        <img
                            className="btn-icon"
                            src={item.icon}
                            alt={item.name}
                        />
                    </button>
                ))}
            </div>
        </div>
    );
};

export default Header;
